import { defineComponent } from 'vue';
import ErrorMessageCode from '@/presentation/components/shared/error-message/error-message.code';

export default defineComponent({
	setup: () => {
		const code = new ErrorMessageCode();

		return {
			errorMessage: code.errorMessage
		};
	}
});
